import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { IacmacImportResource } from 'src/app/models/iiacmac.interface';
import { IPerson, IPersonForm, IPersonOnlineReg } from 'src/app/models/iperson.interface';
import { PersonPaymentForm, PersonPlaceInfoForm, PersonVisitForm } from 'src/app/models/iregistration.interface';
import { GLOBAL_CONVERTERS } from 'src/app/shared/global.converters';

@Injectable({
  providedIn: 'root'
})
export class FormsService {

  private formGroup = new UntypedFormGroup({});

  constructor(private fb: UntypedFormBuilder,) {}

  get(): UntypedFormGroup {
    return this.formGroup;
  }

  register(name: string, formGroup: UntypedFormGroup): void {
    this.formGroup.addControl(name, formGroup);
  }

  unregister(name: string): void {
    this.formGroup.removeControl(name);
  }

  createPersonForm(data: PersonPlaceInfoForm): UntypedFormGroup {
    const form = this.fb.group({
      firstName: new UntypedFormControl(''),
      secondName: new UntypedFormControl(''),
      thirdName: new UntypedFormControl(''),
      phones: new UntypedFormControl([]),
      emails: new UntypedFormControl([]),
      workplace: new UntypedFormControl(''),
      position: new UntypedFormControl(''),
      filterSpecialities: new UntypedFormControl([]),
      specialities: new UntypedFormControl([]),
      // filterGeo: new FormControl(),
      city: new UntypedFormControl(''),
      region: new UntypedFormControl(''),
      country: new UntypedFormControl(''),
    });

    if (data) {
      form.patchValue(data);
    }
    return form;
  }


  createPersonFormMerge1(data: IPersonForm): UntypedFormGroup {
    const form = this.fb.group({
      firstName: new UntypedFormControl(data?.firstName ?? ''),
      secondName: new UntypedFormControl(data?.secondName ?? ''),
      thirdName: new UntypedFormControl(data?.thirdName ?? ''),
      dateBirth: new UntypedFormControl(data?.dateBirth ?? ''),
      sex: new UntypedFormControl(data?.sex ?? ''),
      phones: new UntypedFormControl(data?.phones ?? []),
      emails: new UntypedFormControl(data?.emails ?? []),
      workplace: new UntypedFormControl(data?.workplace ?? ''),
      position: new UntypedFormControl(data?.position ?? ''),
      cityName: new UntypedFormControl(data?.cityName ?? ''),
      scienceDegreeId: new UntypedFormControl(data?.scienceDegreeId || 0),
      scienceStatusId: new UntypedFormControl(data?.scienceStatusId || 0),
      specialities: new UntypedFormControl(data?.specialities ?? []),
      filterGeo: new UntypedFormControl(),
      city: new UntypedFormControl(data?.city ?? ''),
      region: new UntypedFormControl(data?.region ?? ''),
      country: new UntypedFormControl(data?.country ?? ''),
      info: new UntypedFormControl(data?.info ?? '')
    });

    return form;
  }

  createPersonFormMerge2(data: IPerson): UntypedFormGroup {
    const form = this.fb.group({
      firstName: new UntypedFormControl(data?.firstName ?? ''),
      secondName: new UntypedFormControl(data?.secondName ?? ''),
      thirdName: new UntypedFormControl(data?.thirdName ?? ''),
      dateBirth: new UntypedFormControl(data?.dateBirth ?? ''),
      sex: new UntypedFormControl(data?.sex ?? ''),
      phones: new UntypedFormControl(data?.phones ?? []),
      emails: new UntypedFormControl(data?.emails ?? []),
      workplace: new UntypedFormControl(data?.workplace ?? ''),
      position: new UntypedFormControl(data?.position ?? ''),
      cityName: new UntypedFormControl(data?.city ?? ''),
      scienceDegreeId: new UntypedFormControl(data?.scienceDegree?.id || 0),
      scienceStatusId: new UntypedFormControl(data?.scienceStatus?.id || 0),
      specialities: new UntypedFormControl(data?.specialities.map(o => o.id) ?? []),
      // filterGeo: new FormControl(),
      city: new UntypedFormControl(data?.city ?? ''),
      region: new UntypedFormControl(data?.region ?? ''),
      country: new UntypedFormControl(data?.country ?? ''),
      info: new UntypedFormControl(data?.info ?? '')
    });

    return form;
  }

  cretePersonFormIacmac(data: IacmacImportResource) {
    const form = this.fb.group({
      firstName: new UntypedFormControl(data?.firstName ?? ''),
      secondName: new UntypedFormControl(data?.secondName ?? ''),
      thirdName: new UntypedFormControl(data?.thirdName ?? ''),
      dateBirth: new UntypedFormControl(data?.dateBirthday ?? ''),
      sex: new UntypedFormControl( ''),
      phones: new UntypedFormControl(data?.phone.split(',').filter(o => o !== '') ?? []),
      emails: new UntypedFormControl(data?.email.split(',').filter(o => o !== '') ?? []),
      workplace: new UntypedFormControl(data?.workplace ?? ''),
      position: new UntypedFormControl(data?.position ?? ''),
      cityName: new UntypedFormControl(data?.city ?? ''),
      scienceDegreeId: new UntypedFormControl( 0),
      scienceStatusId: new UntypedFormControl( 0),
      specialities: new UntypedFormControl([]),
      // filterGeo: new FormControl(),
      city: new UntypedFormControl(data?.city ?? ''),
      region: new UntypedFormControl(''),
      country: new UntypedFormControl(data?.country ?? ''),
      info: new UntypedFormControl( '')
    });

    return form;
  }

  cretePersonFormOnlineReg(data: IPersonOnlineReg) {
    const form = this.fb.group({
      firstName: new UntypedFormControl(data?.firstName ?? ''),
      secondName: new UntypedFormControl(data?.secondName ?? ''),
      thirdName: new UntypedFormControl(data?.thirdName ?? ''),
      dateBirth: new UntypedFormControl(''),
      sex: new UntypedFormControl( ''),
      phones: new UntypedFormControl(data?.phone?.split(',').filter(o => o !== '') ?? []),
      emails: new UntypedFormControl(data?.email?.split(',').filter(o => o !== '') ?? []),
      workplace: new UntypedFormControl(data?.workplace ?? ''),
      position: new UntypedFormControl(data?.position ?? ''),
      cityName: new UntypedFormControl(data?.city ?? ''),
      scienceDegreeId: new UntypedFormControl( 0),
      scienceStatusId: new UntypedFormControl( 0),
      specialities: new UntypedFormControl([]),
      filterGeo: new UntypedFormControl(),
      city: new UntypedFormControl(data?.city ?? ''),
      region: new UntypedFormControl(data?.region ?? ''),
      country: new UntypedFormControl(data?.country ?? ''),
      info: new UntypedFormControl( '')
    });

    return form;
  }

  createVisitForm(data: PersonVisitForm): UntypedFormGroup {
    const today = GLOBAL_CONVERTERS.getStringFromDateTime(new Date());
    const form = this.fb.group({
      rankId: new UntypedFormControl(0),
      companyId: new UntypedFormControl(0),
      isBadgePrinted: new UntypedFormControl(false),
      isArrive: new UntypedFormControl(false),
      isNeedBadge: new UntypedFormControl(false),
      dateArrive: new UntypedFormControl(today),
      dateRegister: new UntypedFormControl(today),
    });
    if (data) {
      form.patchValue(data);
    }
    return form;
  }

  createPaymentForm(data: PersonPaymentForm): UntypedFormGroup {
    const today = GLOBAL_CONVERTERS.getStringFromDateTime(new Date());
    const form = this.fb.group({
      isPayment: new UntypedFormControl(false),
      datePayment: new UntypedFormControl(today),
      isMaterials: new UntypedFormControl(false),
      // paymentNumber: new FormControl(0),
      paymentDocument: new UntypedFormControl(''),
      paymentTypeId: new UntypedFormControl(0),
      paymentAmount: new UntypedFormControl(1500),
      sponsorId: new UntypedFormControl(0),
    });
    if (data) {
      form.patchValue(data);
    }
    return form;
  }
}
